import styled from 'styled-components';
import { Text } from '../../helpers';
import RoundBox from '../RoundBox/RoundBox';
import AppStoreButton from './AppStoreButton';
import GooglePlayButton from './GooglePlayButton';
import { useTranslation } from 'react-i18next';

const ImageWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: baseline;
    height: 55px;
`;

const MobileAppsButtons = () => {
    const { t } = useTranslation();
    return (
        <RoundBox>
            <Text
                i={t('startUsingService')}
                style={{ textAlign: 'center', marginBottom: '17px' }}
            />
            <ImageWrapper>
                <AppStoreButton width="143px" />
                <GooglePlayButton width="143px" />
            </ImageWrapper>
        </RoundBox>
    );
};

export default MobileAppsButtons;
